import { FileUploadInterface } from '../models/Profile';
import { Communication, tempApi } from '../models/template';

export type listOfTenantsType = {
  email: string;
};

export type loginCred = {
  email: string;
  password: string;
};
export type ItemIdArray = {
  itemId: string[];
};
export type DepartmentList = {
  customer: string;
};
export type roleSettingType = {
  roleId: string;
  roleName: string;
};
export type OrderRegisterPayLoadType = {
  dateOfDelivery: string;
  dateOfReturn: string;
  movementTo: string;
  movementReason: string;
  purpose: string;
  movementType: string;
  modeOfPayment: string;
  amount: string;
};

export type InventoryDelivery_DeliveryPayload = {
  attention: string;
  phone: string;
  shipVia: string;
  shipPriority: string;
  airWay: string;
  account: string;
  pickupBy: string;
  pickupByID: string;
  pickupOn: string;
  shipTo: string;
};

export type scheduleTabSubTasks = {
  subTaskId: string;
  subTaskName: string;
  startSTDate: string;
  endSTDate: string;
  status: number;
};

export type scheduleTabDataType = {
  taskId: string;
  taskName: string;
  subtasks: scheduleTabSubTasks[];
};

export type rescheduleTasksPayloadType = {
  subtaskId: string;
  toDate: string;
};

export type metadataType = {
  elementId: string;
  elementName: string;
  elementType: string;
  elementValue: string;
  elementIndex: number;
  templateElementId: string;
  parentId: string | null;
  hasChild: boolean;
  options: any[];
  enableByDefault: boolean;
};

export type HFCmetadataType = {
  elementName: string;
  elementValue: string;
  isActive:boolean;
};

export type assignUserType = {
  id: string;
  displayname: string;
  roleName: string;
  image: string;
  assigned: boolean;
};

export type itemDetailsType = {
  id: string;
  title: string;
  type: string;
  element: string;
  current_task: string;
  current_subtask: string;
  status: string;
  current_user: string;
  asset_In_Vault: string;
  parent: string | null;
  thumbnail: string;
  preview: string;
  proxy: string;
  registerId: string;
  [key: string]: string | null | undefined;
};

export type physicalAssetsType = {
  id: string;
  physical_sensor_NFC: string;
  physical_sensor_barcode: string;
  physical_sensor_qrcode: string;
  physical_sensor_RFID: string;
  physical_location_rack: string | null;
  physical_location_shelf: string;
  physical_location_vault: string;
  global_positioning_system: string;
  asset_In_Vault: string;
  movement_Time: string;
};

export type HFCphysicalAssetsType ={
  id: string;
  title: string;
  assetId: string;
  container_Barcodes: string;
  reel_Barcodes: string;
  vault:string;
  room: string;
  aisle_No: string;
  shelf: string;
 asset_In_Vault: string;
  movement_Time: string
}

export type subTasks = {
  subTaskId: string;
  subtaskIndex: number;
  subTaskName: string;
  subTaskDateTime: string;
  autoRejectTo: string | null;
  parallelSubtaskId: string | null;
  isFinish: boolean;
  isActive: boolean;
  isDeleted: boolean;
  isCurrentSubtask: boolean;
  tATTime: number;
  startSTDate: string;
  endSTDate: string;
  subTaskstatus: number;
  templateSubtaskId: string;
  actionerName: string;
  // elements: WorkflowElement[];
  elements: [];
  files: FileUploadInterface[];
  communication: Communication[];
  api: tempApi[];
};

export type Task = {
  taskId: string;
  taskIndex: number;
  icon: string | null;
  taskName: string;
  username: string;
  templateTaskId: string;
  status: string | null;
  taskDateTime: string;
  isCurrentTask: boolean;
  isActive: boolean;
  isDeleted: boolean;
  subTasks: subTasks[];
};

export type activeOrderType = {
  templateId: string;
  templateIndex: number;
  templateName: string;
  templateDateTime: string;
  isActive: boolean;
  isDeleted: boolean;
  tasks: Task[];
};

export type FilesFolderType = {
  files: FileUploadInterface[];
  folderName: string;
};

export type itemDeleteDetailsType = {
  itemId: string;
  prodCount: number;
  tolTaskCount: number;
  orderCount: number;
};

export type itemDeleteResponse = {
  files: boolean;
  history: boolean;
  receiving: boolean;
  inward: boolean;
  deliveryRequest: boolean;
  order: boolean;
  item: boolean;
  count: boolean;
};

export type workFlowUpdateResponse = {
  itemId: string;
  prodCount: number;
  tolTask: number;
  compTask: number;
  result: string;
};

export type NFAIworkFlowUpdateResponse ={
  itemId: string;
  templateId: string;
  currentTaskId: string;
  nextTaskId: string;
  currentSubtaskId: string;
  nextSubTaskId: string;
  actionerName: string;
  totalTask: number;
}

export type appLogoType = {
  id: string;
  customerName: string;
  logoUrl: string;
};

export type uploadFileType = {
  id: string;
  files: {
    id: string;
    fileId: string;
    fileName: string;
    url: string;
    addedOn: Date;
  }[];
};

export type nfaiPDF2CSVtype = {
  reels: {
    reelNo: string;
    startFrame: number;
    endFrame: number;
    totalFrame: number;
    totalDurationInMins: string;
  }[];
  itemGroupId: string;
  typeId: string;
  typeName: string;
  elementId: string;
  elementName: string;
  departmentId: string;
  departmentName: string;
  templateId: string;
  excelPath: string;
};

export type acquisitionScanType = {
  registerId: string;
  customer: string;
};

export type registerScanResponse = {
  typeId: string;
  typeName: string;
  elementId: string;
  elementName: string;
  departmentId: string;
  departmentName: string;
  registerId: string;
  templateId: string;
};

export type addItemGroupRes = {
  itemGroupId: string;
  itemGroupName: string;
};

export type cutlistDetailsType = {
  reelData: {
    reelNo: string;
    parentId: string;
    parentName: string;
  }[];
  assetTypeId: string;
  assetTypeName: string;
  elementId: string;
  elementName: string;
  templateId: string;
};

export type vaultListType = {
  id: string;
  name: string;
  gpsLocation: string;
};

export type HFCvaultListType = {
  value(arg0: string, value: any): unknown;
  id: string;
  vaultName: string;
};

export type hfcOutwardRegisterPayload = {
  id: string;
  theater: string;
  location: string;
  account: string;
  amount: string;
  from: string;
  to: string;
  returnDate: string;
};

export type circuitCreationPOST = {
  theater: string;
  address: string;
  deliveryDate: string;
  returnDate: string;
};

export interface circuitType extends circuitCreationPOST {
  index: number;
  status: string;
}

export type tagValidationType = {
  customerName: string;
  vaultName: string;
  rackNo: string;
  shelfNo: string;
};


export interface Option {
  optionId: string;
  optionIndex: number;
  optionName: string;
  optTemplateId: string;
  optionDateTime: string;
  optionLinkId: string;
  optionLinkName: string;
  optionValue: any;
  listOfOptions: string | null;
  optionType: string | null;
  isActive: boolean;
  isSelected: boolean;
  isMulti: boolean;
  isDisabled: boolean;
  isDeleted: boolean;
}

interface Element {
  elementId: string;
  elementIndex: number;
  elementName: string;
  elementType: string;
  elementValue: string;
  elementDateTime: string;
  creatorName: string;
  templateElementId: string;
  dynamicTypeName: string | null;
  dynamicTypeId: string;
  masterId: string | null;
  isActive: boolean;
  isDeleted: boolean;
  enableByDefault: boolean;
  isMultiple: boolean;
  isMandatory: boolean;
  readOnly: boolean;
  isSelectedInOptions: boolean;
  validation: string;
  flexBasis: string | null;
  parentId: string;
  parentName: string | null;
  parentDynamicDetails: {
    parentDynamicId: string;
    templateId: string | null;
    elementTypeId: string | null;
    assetTypeId: string | null;
  };
  options: Option[];
  files: any[];
  photos: any[];
}

export interface workflowSubTask {
  subTaskId: string;
  subtaskIndex: number;
  subTaskName: string;
  subTaskDateTime: string;
  autoRejectTo: any;
  isFinish: boolean;
  isActive: boolean;
  isDeleted: boolean;
  isCurrentSubtask: boolean;
  tATTime: number;
  startSTDate: string;
  endSTDate: string;
  subTaskstatus: number;
  status: number;
  recVersion: string;
  templateSubtaskId: string;
  actionerName: string | null;
  elements: Element[];
  files: any[];
  communication: any[];
  api: any[];
}

export const initialOption: Option = {
  optionId: "",
  optionIndex: 0,
  optionName: "",
  optTemplateId: "",
  optionDateTime: "",
  optionLinkId: "",
  optionLinkName: "",
  optionValue: null,
  listOfOptions: null,
  optionType: null,
  isActive: false,
  isSelected: false,
  isMulti: false,
  isDisabled: false,
  isDeleted: false,
};

export const initialElement: Element = {
  elementId: "",
  elementIndex: 0,
  elementName: "",
  elementType: "",
  elementValue: "",
  elementDateTime: "",
  creatorName: "",
  templateElementId: "",
  dynamicTypeName: null,
  dynamicTypeId: "",
  masterId: null,
  isActive: false,
  isDeleted: false,
  enableByDefault: false,
  isMultiple: false,
  isMandatory: false,
  readOnly: false,
  isSelectedInOptions: false,
  validation: "",
  flexBasis: null,
  parentId: "",
  parentName: null,
  parentDynamicDetails: {
    parentDynamicId: "",
    templateId: null,
    elementTypeId: null,
    assetTypeId: null,
  },
  options: [initialOption],
  files: [],
  photos: [],
};


